import React, { Component } from "react";
import contactAnimationData from "../helper/loading.json";
import Lottie from "react-lottie";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: contactAnimationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default class AnimationLoading extends Component {
  render() {
    return (
      <div
        style={{
          alignSelf: "center",
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "red",
          height: "10vh",
          // position: "absolute",
          // left: 0,
          // zIndex: 999,
          // top: 0,
          width: "100%",
          // backgroundColor: "#ffffffcb",
        }}>
        <div style={{ width: 100 }}>
          <Lottie options={defaultOptions} width={70} />
        </div>
      </div>
    );
  }
}
